import React from 'react';

import StoreContext from './StoreContext';
import useAuth from 'components/Auth/useAuth';
import useClient from 'components/Auth/useClient';

export default function StoreProvider(props)
{
  const state = React.useState({tab: 0, search: false});
  const auth = useAuth();
  const client = useClient();
  React.useEffect(() => {
    if (auth.isUser && auth.emailVerified) {
      client.get(`api/user/viewableReports`)
        .then((response) => {
          const [value, set] = state;
          set({...value, viewableReports: response.data.viewableReports});
      });
    }
  }, [auth]);

  return (
    <StoreContext.Provider value={state}>
      {props.children}
    </StoreContext.Provider>
  );
}